module.exports = __webpack_public_path__ + "img/3@2x.276f3761.png";